import script from "./BoardView.vue?vue&type=script&setup=true&lang=js"
export * from "./BoardView.vue?vue&type=script&setup=true&lang=js"

import "./BoardView.vue?vue&type=style&index=0&id=6b221907&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b221907"]])

export default __exports__